import { useCallback, useEffect, useState } from 'react';
import { handleEvent, JazzRoomEventError, JazzRoomEventStatusChanged } from '@salutejs/jazz-sdk-web';
import { usePoorConnection } from './usePoorConnection';

export const useRoomConnectionStatus = ({room}) => {
    const [ errorMessage, setErrorMessage ] = useState<string | null>();
    const [ statusMessage, setStatusMessage ] = useState<string | null>(null);
    const poorConnection = usePoorConnection(room);

    const handleErrorEvent = useCallback(({ payload: { error: { type } } }: JazzRoomEventError) => {
        switch (type) {
            case 'notAllowed':
                setErrorMessage('В комнате используется неподдерживаемая функция.')
                break;
            case 'accessByPermission':
                setErrorMessage('Доступ в комнату разрешен только по приглашению.')
                break;
            case 'exceededMaxSdkMeetings':
                setErrorMessage('Превышено максимально допустимое количество активных комнат.')
                break;
            case 'openConnection':
                setErrorMessage('Ошибка во время установления соединения с комнатой.')
                break;
            case 'network':
                setErrorMessage('Проблемы с интернет-соединением.')
                break;
            default:
                setErrorMessage('Неизвестная ошибка.')
        }
    }, []);

    const handleStatusChanged = useCallback(({ payload: { status }}: JazzRoomEventStatusChanged) => {
        switch (status) {
            case 'connecting':
                setStatusMessage('Устанавливаем соединение...')
                break;
            case 'disconnecting':
                setStatusMessage('Завершаем соединение...')
                break;
            case 'disconnected':
                setStatusMessage(null)
                break
            case 'error':
                setStatusMessage('Ошибка')
                break;
            default:
                setStatusMessage(null)
        }
    }, []);

    useEffect(() => {
        if (poorConnection) {
            setStatusMessage('Соединение прервано')
        }
    }, [poorConnection])

    useEffect(() => {
        if (room) {
            const unsubscribeError = handleEvent(room.event$, 'error', handleErrorEvent);
            const unsubscribeStatusChanged = handleEvent(room.event$, 'statusChanged', handleStatusChanged);
            return () => {
                unsubscribeError();
                unsubscribeStatusChanged();
            }
        }
    }, [room]);

    return { errorMessage, statusMessage };
}
